import { render, staticRenderFns } from "./spoken.vue?vue&type=template&id=0ec2e697&scoped=true&"
import script from "./spoken.vue?vue&type=script&lang=ts&"
export * from "./spoken.vue?vue&type=script&lang=ts&"
import style0 from "./spoken.vue?vue&type=style&index=0&id=0ec2e697&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec2e697",
  null
  
)

export default component.exports